<template>
  <v-dialog
    v-model="isActive"
    content-class="onboarding-dialog"
    transition="dialog-bottom-transition"
    fullscreen
    hide-overlay
    persistent
  >

    <v-overlay v-if="isLoading" color="#48B38B">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container v-if="form.onboarding" class="pa-0" fluid>
      <div class="signup">
        <div class="s-header">
          <v-img class="img-logo" :src="require('@/assets/logo_check_motors_white.png')"></v-img>
          <v-btn v-if="user.organization.onboarding === 1" @click="close()" text color="#fff" class="ml-2" outlined elevation="0">Fechar</v-btn>
        </div>
        <div class="container">
          <div class="step" :style="{ display: step === 1 ? 'inherit' : 'none' }">
            <div class="image">
              <img :src="require('@/assets/icons/1.svg')" width="100%" />
            </div>
            <div class="number">
              <span>Passo <strong>1</strong> de <strong>4</strong></span>
            </div>
            <div class="title mt-4">
              <h2>Vamos configurar sua conta</h2>
            </div>
            <div class="description mt-4">
              <p>O <strong>CheckMotors</strong> é uma plataforma simplificada que te ajuda a gerenciar a sua empresa de forma rápida e fácil.</p>
            </div>
          </div>
          <div class="step" :style="{ display: step === 2 ? 'inherit' : 'none' }">
            <div class="number">
              <span>Passo <strong>2</strong> de <strong>4</strong></span>
            </div>
            <div class="title mt-4">
              <h2>Precisamos de algumas informações sobre a sua empresa</h2>
            </div>
            <div class="description mt-4">
              <p>Para que possamos te ajudar a gerenciar a sua empresa, precisamos de algumas informações sobre ela.</p>
            </div>
            <div class="form mt-6">
              <v-text-field
                v-model="form.onboarding.cpf_cnpf"
                v-mask="['##.###.###/####-##']"
                disabled
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="CNPJ da empresa"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.name"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Razão social"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.fake_name"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Nome fantasia"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.email"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="E-mail"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.phone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Telefone"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.phone_whatsapp"
                v-mask="['(##) ####-####', '(##) #####-####']"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="WhatsApp"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.address"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Endereço"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.responsible_name"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Nome do responsável (Gerente Geral)"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.onboarding.responsible_whatsapp"
                v-mask="['(##) ####-####', '(##) #####-####']"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="WhatsApp do responsável (Gerente Geral)"
                type="text"
              ></v-text-field>
            </div>
          </div>
          <div class="step" :style="{ display: step === 3 ? 'inherit' : 'none' }">
            <div class="number">
              <span>Passo <strong>3</strong> de <strong>4</strong></span>
            </div>
            <div class="title mt-4">
              <h2>Vamos falar sobre a sua equipe</h2>
            </div>
            <div class="description mt-4">
              <p>Agora, precisamos saber quantos usuários você deseja cadastrar na plataforma.</p>
            </div>
            <div class="form mt-6 mb-4">
              <div class="user-container mb-6">
                <div v-for="(user, index) in form.onboarding.users" :key="index" class="user-item">
                  <div class="user-details">
                    <p><strong>Nome:</strong> {{ user.name }}</p>
                    <p><strong>Telefone:</strong> {{ formatPhone(user.phone) }}</p>
                  </div>
                  <div class="user-actions">
                    <v-btn outlined color="warning" @click="editUser(index)" elevation="0">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn outlined color="error" @click="removeUser(index)" elevation="0">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
                <v-btn
                  v-if="form.onboarding.users?.length !== 0 && form.onboarding.users?.length < 6"
                  large depressed elevation="0"
                  color="primary"
                  @click="isAddUserModalActive = true"
                  text
                  block
                >
                  <v-icon>mdi-plus</v-icon>
                  Adicionar usuário
                </v-btn>
                <div v-if="form.onboarding.users?.length === 0" class="no-user-item">
                  <v-icon size="100px">mdi-account-group-outline</v-icon>
                  <p>Comece adicionando o primeiro usuário</p>
                  <v-btn
                    large
                    depressed
                    elevation="0"
                    color="primary"
                    @click="isAddUserModalActive = true"
                    text
                  >
                    <v-icon>mdi-plus</v-icon>
                    Adicionar usuário
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="step" :style="{ display: step === 4 ? 'inherit' : 'none' }">
            <div class="number">
              <span>Passo <strong>4</strong> de <strong>4</strong></span>
            </div>
            <div class="title mt-4">
              <h2>Configure um site para sua empresa</h2>
            </div>
            <div class="description mt-4">
              <p>Esse é o link que o seu cliente vai acessar para visualizar os serviços, é como uma página do facebook. Digite o nome da sua empresa</p>
            </div>
            <div class="form mt-6">
              <v-text-field
                v-model="form.domain"
                v-debounce:1s="handleDomainChange"
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                outlined
                label="URL"
                prefix="https://relatorio.checkmotors.com/"
                type="text"
                hide-details
                :disabled="
                  (isValidDomain === true &&
                    !!reportSlugFromParameter &&
                    String(form.domain || '').trim() === String(reportSlugFromParameter).trim()) ||
                  domainChecking
                "
              ></v-text-field>
              <v-alert
                dense
                text
                type="success"
                v-if="form.domain && isValidDomain === true"
              >
                Domínio disponível
              </v-alert>
              <v-alert
                dense
                text
                type="error"
                v-if="form.domain && isValidDomain === false"
              >
                Domínio indisponível
              </v-alert>
            </div>
          </div>
          <div class="step" :style="{ display: step === 5 ? 'inherit' : 'none' }">
            <div class="image">
              <img :src="`${require('@/assets/check_animated_transparent.svg')}?v=${Math.random()}`" width="100%" />
            </div>
            <div class="title mt-4">
              <h2>Tudo pronto!</h2>
            </div>
            <div class="description mt-2">
              <p>Você já pode começar a utilizar o <strong>CheckMotors</strong> a partir de agora.</p>
            </div>
          </div>
          <div class="actions">
            <v-btn @click="nextStep()" large depressed color="primary" elevation="0" block :disabled="disabled">{{ confirmationLabel }}</v-btn>
            <v-btn v-if="step !== 1 && step !== 5" @click="previousStep()" dark large depressed color="grey" elevation="0" block>VOLTAR</v-btn>
          </div>
          <v-dialog v-model="isScheduleModalActive" max-width="600">
            <v-card>
              <v-card-title>Horário de Funcionamento</v-card-title>
              <v-card-text>
                <div class="day" v-for="(day, index) in daysOfWeek" :key="index">
                  <v-checkbox v-model="day.opened" :label="day.name" hide-details @click="toggleDay(index)"></v-checkbox>
                  <div v-for="(slot, slotIndex) in day.schedules" :key="slotIndex">
                    <v-row class="ml-4 mt-2" align="center">
                      <v-col cols="5">
                        <v-text-field
                          v-model="slot.openingTime"
                          label="Abre às"
                          readonly
                          dense
                          hide-details
                          outlined
                          @click="selectTime(index, slotIndex, slot.openingTime, 'openingTime')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          v-model="slot.closingTime"
                          label="Fecha às"
                          readonly
                          dense
                          hide-details
                          outlined
                          @click="selectTime(index, slotIndex, slot.closingTime, 'closingTime')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          color="error"
                          @click="day.schedules.splice(slotIndex, 1)"
                          icon
                          elevation="0"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="mt-2" v-if="day.opened && day.schedules.length < day.max">
                    <v-btn @click="addTimeSlot(index)" text color="primary" block elevation="0">
                      <v-icon>mdi-plus</v-icon>
                      Adicionar horário
                    </v-btn>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 32px;">
                  <v-btn color="primary" @click="closeSchedule()" block elevation="0">Ok</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <div class="footer">
          <div @click="openSupportWhatsApp()" style="color: #48c295; margin-bottom: 5px">
            <v-icon color="#48c295" size="20px" style="margin-top: -2px">mdi-whatsapp</v-icon>
            Fale conosco
          </div>
          {{ new Date().getFullYear() }} © <b>CheckMotors v3.7.41</b> <br />
          <a href="https://checkmotors.net/wp-content/uploads/2023/09/Termos-de-uso.pdf" target="_blank" style="color: #b2b2b2;">Termos de uso</a> •
          <a href="https://checkmotors.net/wp-content/uploads/2024/07/Politica-de-privacidade.pdf" target="_blank" style="color: #b2b2b2;">Privacidade</a> •
          <a href="https://checkmotors.net/wp-content/uploads/2023/09/Politica-de-Cookies.pdf" target="_blank" style="color: #b2b2b2;">Cookies</a>
        </div>

        <v-bottom-sheet v-model="isAddUserModalActive" persistent>
          <div class="bottom-sheet-content">
            <div class="bottom-sheet-header">
              <span class="bottom-sheet-title">Adicionar usuário</span>
              <v-btn icon elevation="0" @click="closeAddUserModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-text-field
                v-model="newUser.name"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Nome completo do usuário"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="newUser.phone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                hide-details
                class="mt-4 mb-4 px-0"
                color="#314e5d"
                clearable
                outlined
                label="Telefone do usuário"
                type="text"
              ></v-text-field>

              <v-btn
                v-if="editingIndex === -1"
                class="mb-4"
                color="primary"
                :disabled="!newUser.name || newUser.name.length < 3 || !newUser.phone || newUser.phone.length !== 15"
                block
                large
                elevation="0"
                @click="addUser()"
              >
                Adicionar usuário
              </v-btn>

              <v-btn
                v-if="editingIndex !== -1"
                class="mb-4"
                color="primary"
                :disabled="!newUser.name || !newUser.phone"
                block
                large
                elevation="0"
                @click="saveEditedUser()"
              >
                Salvar edição
              </v-btn>
          </div>
        </v-bottom-sheet>
      </div>
    </v-container>

    <v-dialog
      v-model="isTimePickerActive"
      persistent
      width="290px"
    >
      <v-time-picker
        v-if="isTimePickerActive"
        v-model="time"
        full-width
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="saveTime()"
          elevation="0"
        >
          OK
        </v-btn>
      </v-time-picker>
    </v-dialog>

  </v-dialog>
</template>

<script>
import OnBoardingService from '@/services/api/onBoarding';
import UserService from '@/services/api/user';

export default {
  name: 'OnBoardingDialog',
  emits: ['close'],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    onboarding: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      step: 1,
      isLoading: false,
      isAddUserModalActive: false,
      isActive: this.active,
      form: {
        onboarding: JSON.parse(JSON.stringify(this.onboarding)),
        differentials: [],
        services: [],
        paymentMethods: [],
        about: '',
        facebook: '',
        logo: null,
        banner: null,
        domain: ''
      },
      imageDataUrlLogo: null,
      imageDataUrlBanner: null,
      isValidDomain: null,
      domainChecking: false,
      domainCheckSeq: 0,
      newUser: {
        name: '',
        phone: ''
      },
      time: null,
      isTimePickerActive: false,
      editingIndex: -1,
      isScheduleModalActive: false,
      currentDay: null,
      currentSlot: null,
      currentType: null,
      daysOfWeek: [
        { type:'week', name: 'Segunda à Sexta', schedules: [], opened: true, max: 2 },
        { type:'weekend', name: 'Sábado', schedules: [], opened: true, max: 1 }
      ]
    };
  },
  mounted() {
    document.documentElement.classList.add('overflow-y-hidden');

    this.handleSuggestDomain();
  },
  beforeDestroy() {
    document.documentElement.classList.remove('overflow-y-hidden');
  },
  created() {
    const slug = this.reportSlugFromParameter;
    if (slug) {
      this.form.domain = slug;
      this.$nextTick(() => {
        this.handleDomainChange();
      });
    } else {
      this.form.domain = null;
      this.isValidDomain = null;
    }
  },
  computed: {
    user() {
      return this.$store.getters['Auth/user'];
    },
    reportSlugFromParameter() {
      const raw = this.getOrganizationParameter('NEW_REPORT_ORG_DOMAIN_URL');
      if (!raw || raw === false) return '';
      return this.extractOrgSlugFromUrl(String(raw));
    },
    disabled() {
      if (this.step === 2) {
        return !this.form.onboarding.name
            || !this.form.onboarding.fake_name
            || !this.form.onboarding.email
            || !this.form.onboarding.phone
            || !this.form.onboarding.phone_whatsapp
            || !this.form.onboarding.address
            || !this.form.onboarding.responsible_name
            || !this.form.onboarding.responsible_whatsapp
      }

      if (this.step === 4) {
        return !this.isValidDomain;
      }

      return false;
    },
    differentials() {
      return this.$store.getters['General/organization_differentials'];
    },
    services() {
      return this.$store.getters['General/organization_services'];
    },
    confirmationLabel() {
      let label = 'Próximo';

      if (this.step === 4) {
        label = 'Finalizar';
      } else if (this.step === 5) {
        label = 'Fechar';
      }

      return label;
    },
    paymentMethods() {
      return this.$store.getters['General/organization_payment_methods'];
    },
  },
  watch: {
    isActive(newValue) {
      this.isActive = newValue;
    },
    'form.logo': {
      handler(newLogo){
        if (newLogo) {
          this.loadImage(newLogo, 'imageDataUrlLogo');
        }
      }
    },
    'form.banner': {
      handler(newBanner){
        if (newBanner) {
          this.loadImage(newBanner, 'imageDataUrlBanner');
        }
      }
    },
    'form.domain': {
      handler() {
        this.isValidDomain = null;
      }
    }
  },
  methods: {
    getOrganizationParameter(code) {
      const orgUser = this.$store.getters['Auth/user'];
      const param = orgUser?.organization?.organization_parameters?.find((p) => p.code === code);
      return param ? param.value : false;
    },
    extractOrgSlugFromUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }
      const sanitizedUrl = url.replace(/\/+$/, '');
      const parts = sanitizedUrl.split('/');
      return parts[parts.length - 1] || '';
    },
    handleSuggestDomain() {
      if (this.reportSlugFromParameter) {
        return;
      }

      const { name } = this.form.onboarding;

      if (name) {
        const domain = name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');

        this.form.domain = domain;

        this.$nextTick(() => {
          this.handleDomainChange();
        });
      }
    },
    openSupportWhatsApp() {
      window.open(`whatsapp://send?phone=5565992774481`);
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    close() {
      this.$emit('close');
    },
    nextStep() {
      if (this.step === 1) {
        this.step += 1;
      } else if (this.step === 2) {
        this.handleSetupOrganization();
      } else if (this.step === 3) {
        this.handleSetupUsers();
      } else if (this.step === 4) {
        this.handleSetupDomain();
      } else if (this.step === 5) {
        window.location.href = '/';
      }
    },
    previousStep() {
      this.step -= 1;
    },
    addUser() {
      this.form.onboarding.users.push({
        name: this.newUser.name,
        phone: this.newUser.phone
      });

      this.newUser = {
        name: '',
        phone: ''
      };

      this.isAddUserModalActive = false;
    },
    editUser(index) {
      this.editingIndex = index;
      this.newUser = { ...this.form.onboarding.users[index] };

      this.isAddUserModalActive = true;
    },
    saveEditedUser() {
      const editingUser = this.form.onboarding.users[this.editingIndex];

      if (!editingUser.id) {
        this.form.onboarding.users.splice(this.editingIndex, 1, { ...this.newUser });

        this.editingIndex = -1;

        this.newUser = {
          name: '',
          phone: ''
        };

        this.isAddUserModalActive = false;
      } else {
        this.isLoading = true;

        OnBoardingService.updateUser(editingUser.id, this.newUser)
          .then((response) => {
            if (response.data.message === 'success') {
              this.form.onboarding.users.splice(this.editingIndex, 1, { ...this.newUser });

              this.editingIndex = -1;

              this.newUser = {
                name: '',
                phone: ''
              };

              this.isAddUserModalActive = false;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    closeAddUserModal() {
      this.isAddUserModalActive = false;

      this.newUser = {
        name: '',
        phone: ''
      };

      this.editingIndex = -1;
    },
    removeUser(index) {
      if (!this.form.onboarding.users[index].id) {
        this.form.onboarding.users.splice(index, 1);
      } else {
        this.isLoading = true;

        UserService.inactivate(this.form.onboarding.users[index].id)
          .then(() => {
            this.form.onboarding.users.splice(index, 1);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    openSchedule() {
      this.isScheduleModalActive = true;
    },
    closeSchedule() {
      this.isScheduleModalActive = false;
    },
    addTimeSlot(index) {
      this.daysOfWeek[index].schedules.push({
        openingTime: "",
        closingTime: ""
      });
    },
    toggleDay(indexDay) {
      if (!this.daysOfWeek[indexDay].opened) {
        this.daysOfWeek[indexDay].schedules = [];
      }
    },
    saveTime() {
      this.daysOfWeek[this.currentDay].schedules[this.currentSlot][this.currentType] = this.time;
      this.time = null;
      this.isTimePickerActive = false;
    },
    selectTime(indexDay, indexSlot, time, type) {
      this.time = time;
      this.currentDay = indexDay;
      this.currentSlot = indexSlot;
      this.currentType = type;
      this.isTimePickerActive = true;
    },
    toggleDifferential(index) {
      const selectedDifferential = this.differentials[index];
      const selectedDifferentialIndex = this.form.differentials.indexOf(selectedDifferential);

      if (selectedDifferentialIndex === -1) {
        this.form.differentials.push(selectedDifferential);
      } else {
        this.form.differentials.splice(selectedDifferentialIndex, 1);
      }
    },
    toggleService(index) {
      const selectedService = this.services[index];
      const selectedServiceIndex = this.form.services.indexOf(selectedService);

      if (selectedServiceIndex === -1) {
        this.form.services.push(selectedService);
      } else {
        this.form.services.splice(selectedServiceIndex, 1);
      }
    },
    togglePaymentMethod(index) {
      const selectedPaymentMethod = this.paymentMethods[index];
      const selectedPaymentMethodIndex = this.form.paymentMethods.indexOf(selectedPaymentMethod);

      if (selectedPaymentMethodIndex === -1) {
        this.form.paymentMethods.push(selectedPaymentMethod);
      } else {
        this.form.paymentMethods.splice(selectedPaymentMethodIndex, 1);
      }
    },
    async handleSetupWebsite(){
      this.isLoading = true;

      const form = {
        schedule: {
          week_morning_start: this.daysOfWeek[0].schedules[0]?.openingTime || "07:00:00",
          week_morning_end: this.daysOfWeek[0].schedules[0]?.closingTime || "11:00:00",
          week_afternoon_start: this.daysOfWeek[0].schedules[1]?.openingTime || "13:00:00",
          week_afternoon_end: this.daysOfWeek[0].schedules[1]?.closingTime || "17:00:00",
          weekend_morning_start: this.daysOfWeek[1].schedules[0]?.openingTime || "07:30:00",
          weekend_morning_end: this.daysOfWeek[1].schedules[0]?.closingTime || "11:30:00",
        },
        differentials: this.form.differentials,
        bosch: false,
        about: this.form.about ?? '',
        payment_methods: this.form.paymentMethods,
        facebook: this.form.facebook,
        services: this.form.services,
      };

      try {
        const response = await OnBoardingService.setupWebsite(form);

        if (response.data.message === "success") {
          if (this.form.logo) {
            await this.uploadImage(response.data.website.id, this.form.logo, 'logo');
          }

          if (this.form.banner) {
            await this.uploadImage(response.data.website.id, this.form.banner, 'banner');
          }

          this.isLoading = false;
          this.step += 1;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async uploadImage(websiteId, file, type) {
      const formData = new FormData();
      formData.append('file', file);

      await OnBoardingService.uploadImage(websiteId, formData, type);
    },
    loadImage(file, dataUrlVariable) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this[dataUrlVariable] = event.target.result;
      };
      reader.readAsDataURL(file);
    },
    clearLogo() {
      this.form.logo = null;
      this.imageDataUrlLogo = null;
    },
    clearBanner() {
      this.form.banner = null;
      this.imageDataUrlBanner = null;
    },
    handleDomainChange() {
      const slug = this.form.domain && String(this.form.domain).trim();

      if (!slug) {
        this.isValidDomain = null;
        this.domainChecking = false;
        return;
      }

      if (!this.isValidDomainString(slug)) {
        this.isValidDomain = false;
        this.domainChecking = false;
        return;
      }

      this.domainCheckSeq += 1;
      const seq = this.domainCheckSeq;
      this.domainChecking = true;

      OnBoardingService.validateDomain({ slug })
        .then(({ data }) => {
          if (seq !== this.domainCheckSeq) return;
          const taken = data && data.already_exists === true;
          this.isValidDomain = !taken;
        })
        .catch(() => {
          if (seq !== this.domainCheckSeq) return;
          this.isValidDomain = false;
        })
        .finally(() => {
          if (seq === this.domainCheckSeq) {
            this.domainChecking = false;
          }
        });
    },
    isValidDomainString(domain) {
      const re = /^[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]$/;
      return domain.length === 1 ? /^[a-zA-Z0-9]$/.test(domain) : re.test(domain);
    },
    handleSetupOrganization(){
      this.isLoading = true;

      const form = {
        name: this.form.onboarding.name,
        fake_name: this.form.onboarding.fake_name,
        email: this.form.onboarding.email.trim().toLowerCase(),
        phone: this.form.onboarding.phone,
        phone_whatsapp: this.form.onboarding.phone_whatsapp,
        address: this.form.onboarding.address,
        responsible_name: this.form.onboarding.responsible_name,
        responsible_whatsapp: this.form.onboarding.responsible_whatsapp,
        id_external: this.form.onboarding.id_external,
      };

      OnBoardingService.setupOrganization(form)
        .then((response) => {
          if (response.data.message === 'success') {
            this.step += 1;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleSetupUsers(){
      const form = {
        users: this.form.onboarding.users.filter((user) => !user.id)
      };

      if (form.users.length === 0) {
        this.step += 1;
        return;
      }

      this.isLoading = true;

      OnBoardingService.setupUsers(form)
        .then((response) => {
          if (response.data.message === 'success') {
            this.step += 1;

            this.form.onboarding.users = response.data.createdUsers;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async handleSetupDomain(){

      this.isLoading = true;

      try {
        const response = await OnBoardingService.setupDomainV2({ domain: this.form.domain });

        if (response.status === 200) {
          this.step += 1;
        }
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.isLoading = false
      }
    },
    formatPhone(phone) {
      const number = phone.replace(/\D/g, "");

      if (number.length === 10) {
        this.formattedPhoneNumber = `(${number.substring(0, 2)}) ${number.substring(
          2,
          6
        )}-${number.substring(6)}`;
      } else if (number.length === 11) {
        this.formattedPhoneNumber = `(${number.substring(0, 2)}) ${number[2]} ${number.substring(
          3,
          7
        )}-${number.substring(7)}`;
      } else {
        this.formattedPhoneNumber = "";
      }

      return this.formattedPhoneNumber;
    },
  }
};
</script>

<style lang="scss">
a:link {
  text-decoration: none;
}

.v-dialog {
  background-color: #F5F5F5 !important;
}

.container {

  .signup {
    .s-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: rgb(63, 80, 95);
      width: 100%;
      padding: 10px;
      position: sticky;
      top: 0;
      z-index: 1;

      .img-logo {
        flex: none !important;
        max-width: 121px;
      }
    }

    .container {

      .step {
        padding: 20px 20px 0 20px;

        .form {

          .user-container {
            border: 1px solid #ccc;
            border-radius: 4px;

            .user-item {
              display: flex;
              justify-content: space-between;
              padding: 8px;
              border-radius: 4px;
              gap: 6px;

              .user-details {
                align-items: flex-start;
                display: flex;
                flex-direction: column;
                justify-content: center;
                flex: 1;
                word-break: break-all;

                p {
                  margin: 0;
                }

                strong {
                  font-weight: bold;
                }
              }

              .user-actions {
                display: flex;
                gap: 8px;
                justify-content: center;
                flex-direction: column;
              }
            }

            .user-item:not(:last-child) {
              border-bottom: 1px solid #ccc;
            }

            .no-user-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              gap: 8px;
              padding: 16px;

              p {
                margin: 0;
              }
            }
          }

          .image-preview {
            border: 1px solid #ccc;
            padding: 26px;
            position: relative;
            display: inline-block;
            margin-top: 20px;
          }

          .image-preview img {
            max-width: 100%;
            height: auto;
          }

          .close-button {
            position: absolute;
            top: -10px;
            right: -10px;
            background-color: #ccc;
            border-radius: 50%;
            padding: 5px;
            border: none;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .schedule {
            background: white;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 20px;

            .check-icon {
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 4px;
              border: 1px solid #48c295;
              min-height: 70px;
            }

            .day-schedules {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
          }
        }
      }

      .actions {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 20px;
        position: sticky;
        bottom: 0;
        background: #F5F5F5;
      }
    }

    .footer {
      color: #b2b2b2;
      font-size: 12px;
      text-align: center;
      padding-bottom: 20px;
    }
  }
}

.bottom-sheet-content {
  padding: 16px;

  .bottom-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .bottom-sheet-title {
      font-size: 18px;
      font-weight: 500;
    }
  }
}
</style>
